import React, { createContext, useEffect } from "react";
import "./App.css";
import RouteApp from "./routers/router";

// const user = JSON.parse(localStorage.getItem("user") ?? "false");

const AuthContext = createContext(null);

function App() {
  useEffect(() => {
    document.title = "ระบบส่งเอกสาร มคอ. และ อชว.";
  }, []);
  return (
    <AuthContext.Provider value={null}>
      <div className="App">
        <RouteApp />
      </div>
    </AuthContext.Provider>
  );
}

export { AuthContext };

export default App;
